import { Box, Card, Text, Stack } from '@mantine/core'

import { TariffCalculatorResultsView } from '~/widgets/TariffCalculator/components/TariffCalculatorResultsView'
import { TariffCalculatorSubmissionView } from '~/widgets/TariffCalculator/components/TariffCalculatorSubmissionView'
import { useEmailCapture } from '~/widgets/TariffCalculator/hooks/useEmailCapture'
import { useTariffCalculator } from '~/widgets/TariffCalculator/hooks/useTariffCalculator'

export function TariffCalculatorInner() {
  // Business logic hooks
  const { form, showResults, isCalculating, result, error, handleCalculate } =
    useTariffCalculator()

  const {
    emailForm,
    isSubmittingEmail,
    emailSubmitted,
    handleEmailSubmit,
    handleDemoClick,
  } = useEmailCapture({
    product: form.values.product,
    country: form.values.country,
  })

  return (
    <Box p="lg">
      <Stack gap="md">
        {!showResults ? (
          // Submission step - full view
          <TariffCalculatorSubmissionView
            form={form}
            isCalculating={isCalculating}
            onSubmit={handleCalculate}
          />
        ) : (
          // Results step - full view (no form visible)
          <TariffCalculatorResultsView
            isCalculating={isCalculating}
            result={result}
            product={form.values.product}
            country={form.values.country}
            emailForm={emailForm}
            isSubmittingEmail={isSubmittingEmail}
            emailSubmitted={emailSubmitted}
            onEmailSubmit={handleEmailSubmit}
            onDemoClick={handleDemoClick}
          />
        )}

        {/* Error Display */}
        {error && (
          <Card withBorder p="md" mt="lg" style={{ borderColor: 'red' }}>
            <Text c="red">{error}</Text>
          </Card>
        )}
      </Stack>
    </Box>
  )
}
